import { SETAUTHOR, SETCATEGORY, SETKEYWORD } from "./actionTypes"
import filter from "./initialFilter"
const filterReducer = (state = filter, action) => {
    state = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SETCATEGORY:
            return {
                ...state,
                category: action.payload
            }
        case SETAUTHOR:
            return {
                ...state,
                author: action.payload
            }
        case SETKEYWORD:
            return {
                ...state,
                keyword: action.payload
            }
        default:
            return state;
    }
}

export default filterReducer;
